import { createBrowserRouter } from 'react-router-dom'
import App from './App'
import HotDealList from './components/home/HotDealList'
import AddCard from './pages/AddCard'
import Bridge from './pages/Bridge'
import Close from './pages/Close'
import CloseT from './pages/CloseT'
import CloseTest from './pages/CloseTest'
import Error from './pages/Error'
import ErrorPage from './pages/ErrorPage'
import Event100wonshop from './pages/event/Event100wonshop'
import EventDetail from './pages/event/eventdetail'
import EventList from './pages/event/eventlist'
import OpenEvent from './pages/event/OpenEvent'
import ExhibitionDetail from './pages/exhibition/exhibition-detail'
import ExhibitionList from './pages/exhibition/exhibition-list'
import Festival from './pages/festivals/Festival'
import FestivalCategory from './pages/festivals/FestivalCateogry'
import FestivalSection from './pages/festivals/FestivalSection'
import Home from './pages/Home'
import PhoneChange from './pages/member/phonechange'
import PhoneModify from './pages/member/PhoneModify'
import Profile from './pages/member/profile'
import Sanctions from './pages/member/Sanctions'
import Sign from './pages/member/sign'
import SignAgree from './pages/member/SignAgrees'
import SignInfo from './pages/member/signinfo'
import SignIntro from './pages/member/SignIntro'
import SignUpCompleted from './pages/member/SignUpCompleted'
import WithdrawalOne from './pages/member/WithdrawalOne'
import WithdrawalResult from './pages/member/WithdrawalResult'
import WithdrawalThree from './pages/member/WithdrawalThree'
import WithdrawalTwo from './pages/member/WithdrawalTwo'
import MypayPaid from './pages/MypayPaid'
import MypayReady from './pages/MypayReady'
import AddressChange from './pages/myshopping/AddressChange'
import Benefit from './pages/myshopping/Benefit'
import CoinDetail from './pages/myshopping/CoinDetail'
import Coupon from './pages/myshopping/Coupon'
import FaqList from './pages/myshopping/FaqList'
import FaqView from './pages/myshopping/FaqView'
import GuestOrderList from './pages/myshopping/GuestOrderList'
import GuestOrderPassword from './pages/myshopping/GuestOrderPassword'
import InquiryList from './pages/myshopping/InquiryList'
import InquiryView from './pages/myshopping/InquiryView'
import InquiryWrite from './pages/myshopping/InquiryWrite'
import MemberBenefit1 from './pages/myshopping/MemberBenefit1'
import MemberBenefit2 from './pages/myshopping/MemberBenefit2'
import MemberBenefit3 from './pages/myshopping/MemberBenefit3'
import MyCoupon from './pages/myshopping/MyCoupon'
import MyShopping from './pages/myshopping/MyShopping'
import NoticeList from './pages/myshopping/NoticeList'
import NoticeView from './pages/myshopping/NoticeView'
import OrderCancel from './pages/myshopping/OrderCancel'
import OrderCancelComplete from './pages/myshopping/OrderCancelComplete'
import OrderDetail from './pages/myshopping/OrderDetail'
import OrderListInquiry from './pages/myshopping/OrderListInquiry'
import OrderRefund from './pages/myshopping/OrderRefund'
import OrderRefundComplete from './pages/myshopping/OrderRefundComplete'
import PrepareReviewList from './pages/myshopping/PrepareReviewList'
import ProductQnaList from './pages/myshopping/ProductQnaList'
import ProductQnaWrite from './pages/myshopping/ProductQnaWrite'
import PushSetting from './pages/myshopping/PushSetting'
import RecentView from './pages/myshopping/RecentView'
import ReviewWrite from './pages/myshopping/ReviewWrite'
import SaveDetail from './pages/myshopping/SaveDetail'
import Wishlist from './pages/myshopping/WishList'
import WrittenReviewList from './pages/myshopping/WrittenReview'
import NaverClose from './pages/NaverClose'
import NaverPay from './pages/NaverPay'
import Order from './pages/order/Order'
import OrderPage from './pages/order/OrderPage'
import OrderComplete from './pages/order/OrderComplete'
import HotdealPage from './pages/outlet/Hotdeal'
import Outlet from './pages/outlet/Outlet'
import Page from './pages/Page'
import Page1 from './pages/Page1'
import ProductDetail from './pages/product/ProductDetail'
import Product from './pages/product/ProductList'
import Search from './pages/search/Search'
import SearchResult from './pages/search/SearchResult'
import PrivacyPolicy from './pages/util/PrivacyPolicy'
import RefundPolicy from './pages/util/RefundPolicy'
import Terms from './pages/util/Terms'
import Oauth from './pages/member/Oauth'
import CartPage from './pages/cart/CartPage'

export const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    title: '',
    errorElement: <ErrorPage />,
    children: [
      { index: true, element: <Home />, title: '홈' },

      // {
      //   path: '/[m1]',
      //   element: <Home />,
      //   title: '홈'
      // },

      // 상품목록(카테고리)
      {
        path: '/category/:twoDepno/:threeDepno/:fourDepno',
        element: <Product />,
        title: '',
      },
      {
        path: '/festivalcategory/:twoDepno/:threeDepno/:fourDepno',
        element: <FestivalCategory />,
        title: '',
      },
      {
        path: '/festivalsection',
        element: <FestivalSection />,
        title: '',
      },
      // 상품목록(브랜드)
      // {
      //   path: '/category/:onebrandno/:twobrandno',
      //   element: <Product />,
      //   title: '',
      // },
      // 상품상세
      { path: '/product/:id', element: <ProductDetail />, title: '' },

      // 장바구니
      // { path: '/cart', element: <CartList />, title: '장바구니' },
      { path: '/cart', element: <CartPage />, title: '장바구니' },

      // 검색
      { path: '/search', element: <Search />, title: '검색' },
      //검색 결과
      {
        path: '/search/searchResult',
        element: <SearchResult />,
        title: '검색 결과',
      },

      // 마이쇼핑
      { path: '/myshopping', element: <MyShopping />, title: '마이쇼핑' },
      // 주문 내역 조회
      {
        path: '/orderlistinquiry',
        element: <OrderListInquiry />,
        title: '주문 내역 조회',
      },
      {
        path: '/guestorderlist',
        element: <GuestOrderList></GuestOrderList>,
        title: '비회원 내역조회 로그인',
      },
      {
        path: '/guestorderpassword',
        element: <GuestOrderPassword></GuestOrderPassword>,
        title: '비회원 내역조회 비밀번호 찾기',
      },
      // 주문 내역 조회 상세
      {
        path: '/orderdetail/:orderNo',
        element: <OrderDetail />,
        title: '주문 내역 조회 상세',
      },
      // 환불 신청
      {
        path: '/orderrefund',
        element: <OrderRefund />,
        title: '환불 신청',
      },
      // 환불 신청 완료
      {
        path: '/orderrefundcomplete',
        element: <OrderRefundComplete />,
        title: '환불 신청 완료',
      },
      // 주문 취소 신청 완료
      {
        path: '/ordercancelcomplete',
        element: <OrderCancelComplete />,
        title: '주문 취소 신청 완료',
      },
      // 주문 취소 신청
      {
        path: '/ordercancel',
        element: <OrderCancel />,
        title: '주문 취소 신청',
      },
      // 리뷰 목록
      {
        path: '/reviewlist/prepare',
        element: <PrepareReviewList />,
        title: '리뷰 작성대기 목록',
      },
      // 리뷰 작성
      { path: '/reviewwrite', element: <ReviewWrite />, title: '리뷰 작성' },
      // 쿠폰
      { path: '/coupon', element: <Coupon />, title: '쿠폰' },
      // 마이 쿠폰
      { path: '/mycoupon', element: <MyCoupon />, title: '마이 쿠폰' },
      // 피싱 코인 내역
      { path: '/coindetail', element: <CoinDetail />, title: '피싱 코인 내역' },
      // 적립금 내역
      { path: '/accumulation', element: <SaveDetail />, title: '적립금 내역' },
      {
        path: '/reviewwrite/:id',
        element: <ReviewWrite />,
        title: '리뷰 목록',
      },
      {
        path: '/reviewlist/written',
        element: <WrittenReviewList />,
        title: '작성한리뷰',
      },

      // 1:1 문의
      { path: '/inquiryList', element: <InquiryList />, title: '1:1 문의' },
      // 1:1 문의 보기
      {
        path: '/inquiryView',
        element: <InquiryView />,
        title: '1:1 문의 보기',
      },
      // 1:1 문의 작성
      {
        path: '/inquiryWrite',
        element: <InquiryWrite />,
        title: '1:1 문의 작성',
      },
      // 상품 Q&A 목록
      {
        path: '/productQnaList',
        element: <ProductQnaList />,
        title: '상품 Q&A 목록',
      },
      {
        path: '/productQnaWrite',
        element: <ProductQnaWrite />,
        title: '상품 Q&A 목록 작성',
      },

      // 공지사항
      { path: '/noticeList', element: <NoticeList />, title: '공지사항' },
      // 공지사항 상세
      {
        path: '/noticeView/:id',
        element: <NoticeView />,
        title: '공지사항 상세',
      },
      // 자주 묻는 질문
      { path: '/faqList', element: <FaqList />, title: '자주 묻는 질문' },
      // 자주 묻는 질문 상세
      {
        path: '/faqView/:id',
        element: <FaqView />,
        title: '자주 묻는 질문 상세',
      },

      // 혜택안내
      { path: '/benefit', element: <Benefit />, title: '혜택안내' },

      // 회원 혜택1 - 기록 작성 가이드
      {
        path: '/recordGuide',
        element: <MemberBenefit1 />,
        title: '기록 작성 가이드',
      },
      // 회원 혜택2 - 코인 획득법
      {
        path: '/coinGuide',
        element: <MemberBenefit2 />,
        title: '코인 획득법',
      },
      // 회원 혜택3 - 쇼핑 가이드
      {
        path: '/shoppingGuide',
        element: <MemberBenefit3 />,
        title: '쇼핑 가이드',
      },

      // 푸시 알림 설정
      {
        path: '/pushSetting',
        element: <PushSetting />,
        title: '푸시 알림 설정',
      },

      // 회원탈퇴1
      {
        path: '/withdrawalOne',
        element: <WithdrawalOne />,
        title: '회원 탈퇴1',
      },
      // 회원탈퇴2
      {
        path: '/withdrawalTwo',
        element: <WithdrawalTwo />,
        title: '회원 탈퇴2',
      },
      // 회원탈퇴3
      {
        path: '/withdrawalThree',
        element: <WithdrawalThree />,
        title: '회원 탈퇴3',
      },
      // 회원탈퇴 완료
      {
        path: '/withdrawalResult',
        element: <WithdrawalResult />,
        title: '회원 탈퇴 완료',
      },
      // 제재회원
      { path: '/sanctions', element: <Sanctions />, title: '제재회원' },

      // 페이지
      { path: '/page', element: <Page /> },

      // 페이지 TEST
      { path: '/pageone', element: <Page1 /> },
      //최근 본 상품
      {
        path: '/recentView',
        element: <RecentView />,
        title: '최근 본 상품',
      },
      //좋아요 한 상품(위시리스트)
      { path: '/wishList', element: <Wishlist />, title: '위시리스트' },

      //주문하기
      // { path: '/order/:orderSheetNo', element: <Order />, title: '주문하기' },
      { path: '/order/:orderSheetNo', element: <OrderPage />, title: '주문하기' },
      //주문완료
      { path: '/orderFinish', element: <OrderComplete />, title: '주문완료' },

      // 배송지 변경
      {
        path: '/AddressChange',
        element: <AddressChange />,
        title: '배송지 변경',
      },

      // 프로필 편집
      { path: '/profile', element: <Profile />, title: '프로필 수정' },
      // 휴대폰번호 수정
      {
        path: '/phonemodify',
        element: <PhoneModify />,
        title: '휴대폰번호 수정',
      },
      // 로그인/회원가입
      { path: '/sign', element: <Sign />, title: '로그인 회원가입' },
      // 로그인/회원가입 약관
      {
        path: '/signAgree',
        element: <SignAgree />,
        title: '로그인 회원가입 약관',
      },
      // 로그인/회원가입 기본정보 입력
      {
        path: '/signinfo',
        element: <SignInfo />,
        title: '로그인 회원가입  기본정보 입력',
      },
      // 회원가입 완료
      {
        path: '/SignUpCompleted',
        element: <SignUpCompleted />,
        title: '회원가입 완료',
      },
      // 로그인/회원가입 인트로
      {
        path: '/SignIntro',
        element: <SignIntro />,
        title: '로그인/회원가입 인트로',
      },
      // 휴대폰번호 변경
      {
        path: '/phonechange',
        element: <PhoneChange />,
        title: '휴대폰번호 변경',
      },

      // 기획전 목록
      {
        path: '/exhibitionlist',
        element: <ExhibitionList />,
        title: '기획전 목록',
      },
      // 기획전 상세
      {
        path: '/exhibitiondetail/:eventNo',
        element: <ExhibitionDetail />,
        title: '기획전 상세',
      },
      // 이벤트 목록
      {
        path: '/eventlist',
        element: <EventList />,
        title: '이벤트 목록',
      },
      // 이벤트 상세
      {
        path: '/eventdetail/:eventNo',
        element: <EventDetail />,
        title: '이벤트 상세',
      },
      // 오픈 이벤트
      {
        path: '/openevent',
        element: <OpenEvent />,
        title: '쇼핑몰 새단장 오픈 기념 혜택',
      },
      // 100원샵 이벤트 페이지
      {
        path: '/event_100wonshop',
        element: <Event100wonshop />,
        title: '첫구매 100원샵 이벤트 페이지',
      },
      // 아웃렛
      { path: '/outlet', element: <Outlet />, title: '아웃렛' },
      { path: '/close', element: <Close></Close>, title: '닫는곳' },
      {
        path: '/closetest',
        element: <CloseTest></CloseTest>,
        title: '팝업 테스트',
      },

      {
        path: '/terms',
        element: <Terms />,
        title: '이용약관',
      },
      {
        path: '/privacypolicy',
        element: <PrivacyPolicy />,
        title: '개인정보 취급방침',
      },
      {
        path: '/refundpolicy',
        element: <RefundPolicy />,
        title: '환불정책',
      },
      {
        path: '/closet',
        element: <CloseT />,
        title: '쇼핑',
      },
      {
        path: '/hotdeal',
        element: <HotdealPage />,
        title: '핫딜',
      },
      {
        path: '/hotdeallist',
        element: <HotDealList />,
        title: '핫딜',
      },
      {
        path: '/bridge',
        element: <Bridge></Bridge>,
        title: '브릿지',
      },
      {
        path: '/myPayReady',
        element: <MypayReady></MypayReady>,
        title: '마이페이용',
      },
      { path: '/addcard', element: <AddCard></AddCard>, title: '카드등록' },
      { path: '/error', element: <Error></Error>, title: '에러페이지' },
      {
        path: '/mypaypaid',
        element: <MypayPaid></MypayPaid>,
        title: '마이페이 결제 ',
      },
      {
        path: '/naverpay',
        element: <NaverPay></NaverPay>,
      },

      { path: '/naverclose', element: <NaverClose></NaverClose> },
      { path: '/festivals/:url', element: <Festival></Festival> },
      { path: '/myshopping/oauth', element: <Oauth></Oauth> },
      // {
      //   path: '/100wonshop',
      //   element: <FirstPurchase></FirstPurchase>,
      //   title: '100원샵',
      // },
    ],
  },
])
